@if (routerEvent$ | async) {}

<div
  class="flex align-items-center justify-content-center top-header-tab relative active-tab"
  #headerTab
>
  <div class="active-left"></div>
  <div class="inner-tab-container">
    <a
      class="inner-tab flex align-items-center gap-1"
      (click)="op.toggle($event)"
    >
      <span class="webkit-box-one-line body-medium-medium">{{
        navigationItem().name
      }}</span>
      <em class="ml-auto icon-caret-down"></em>
    </a>
    <p-popover #op>
      @if (navigationItem$ | async) {
        <div class="overlay-body">
          @if (navigationItem().children.length) {
            @for (item of navigationItem().children; track $index) {
              <st-menu-collapse-item
                [menuItemData]="item"
                [active]="activeChild && activeChild.id === item.id"
              ></st-menu-collapse-item>
            }
          }
        </div>
      }
    </p-popover>
  </div>
  <div class="active-right"></div>
</div>
